'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

var _addClass = require('../helpers/dom/add-class');

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = require('../helpers/dom/remove-class');

var _removeClass2 = _interopRequireDefault(_removeClass);

var _outerHeight = require('../helpers/dom/outer-height');

var _outerHeight2 = _interopRequireDefault(_outerHeight);

var _hasClass = require('../helpers/dom/has-class');

var _hasClass2 = _interopRequireDefault(_hasClass);

var _debounce = require('../helpers/util/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _breakpoint = require('../helpers/dom/breakpoint');

var _parseAttribute = require('../helpers/dom/parse-attribute');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * # Fixed Panel
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * new FixedPanel(el);
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module components/fixed-panel.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var FixedPanel = function (_BaseComponent) {
  _inherits(FixedPanel, _BaseComponent);

  /**
   * Fixed Panel constructor.
   * @param {Element} el
   * @param {Object} params
   */
  function FixedPanel(el) {
    var _this;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, FixedPanel);

    params.elRequired = true;

    if (!(_this = _possibleConstructorReturn(this, _BaseComponent.call(this, el, params)), _this)) {
      return _possibleConstructorReturn(_this);
    }
    _this._bindEventListenerCallbacks();
    _this._addListeners();
    _this._setPanelLocation();
    return _possibleConstructorReturn(_this);
  }

  /**
   * Parse parameters from the elements.
   */


  FixedPanel.prototype._parseParams = function _parseParams() {
    this.hideOnScroll = this.hideOnScroll || (0, _parseAttribute.boolean)(this.el, 'data-hide-on-scroll', false);
    this.fixToBottom = this.fixToBottom || (0, _parseAttribute.boolean)(this.el, 'data-fixed-to-bottom', false);
    this.condenseOnScroll = this.condenseOnScroll || (0, _parseAttribute.boolean)(this.el, 'data-condense', false);
    this.unlockBreakPoint = this.unlockBreakPoint || (0, _parseAttribute.string)(this.el, 'data-breakpoint', null);
    this.documentBody = document.querySelector('body');

    // Checks to see if a non-Spark header is provided by the user
    if (this.headerEl !== null) {
      this.foreignHeader = true;
    } else {

      // If no header is given then, search for a Spark header.
      this.headerEl = document.querySelector('.spark-header:not(.spark-header__placeholder)');
    }
  };

  /**
   * Add Fixed Panel window listeners
   */


  FixedPanel.prototype._addListeners = function _addListeners() {
    window.addEventListener('scroll', this._onScrollBound);
    window.addEventListener('resize', this._onResizeBound);

    // if there is a header it may have transitions that change the height, watch for it and adjust accordingly
    if (this.headerEl) {
      if (window.getComputedStyle(this.headerEl).getPropertyValue('transition') !== "") {
        this.headerEl.addEventListener('transitionend', this._onResizeBound);
      }
    }
  };

  /**
   * Remove Fixed Panel window listeners
   */


  FixedPanel.prototype._removeListeners = function _removeListeners() {
    window.removeEventListener('scroll', this._onScrollBound);
    window.removeEventListener('resize', this._onResizeBound);
    if (this.headerEl) {
      if (window.getComputedStyle(this.headerEl).getPropertyValue('transition') !== "") {
        this.headerEl.removeEventListener('transitionend', this._onResizeBound);
      }
    }
  };

  /**
   * Create bound versions of event listener callbacks and store them.
   * Otherwise we can't unbind from these events later because the
   * function signatures won't match.
   */


  FixedPanel.prototype._bindEventListenerCallbacks = function _bindEventListenerCallbacks() {
    this._onScrollBound = this._onScroll.bind(this);
    this._onResizeBound = (0, _debounce2.default)(this._onResize.bind(this), 100);
  };

  /**
   * Sets up references
   * @param  {Element} el base DOM element
   */


  FixedPanel.prototype._cacheElements = function _cacheElements(el) {
    this.el = el;
  };

  /**
   * This method will determine where on the viewport the Fixed Panel will dock to,
   * and gets the dimensions of the Fixed Panel and Header (if fixed to the top of the viewport).
   */


  FixedPanel.prototype._setPanelLocation = function _setPanelLocation() {
    this.currentScrollPosition = window.pageYOffset !== undefined ? window.pageYOffset : window.document.body.scrollTop;
    this._getPanelDimensions();

    if (this.fixToBottom) {
      // Adding padding to the bottom of the body equivalent to the height of the
      // Fixed Panel when using the "fix to bottom" config
      if (this.documentBody) {
        this.documentBody.style['padding-bottom'] = this.panelHeight + 'px';
      }
    } else if (this.headerEl) {
      // Gets the next Element of page content below the Fixed Panel
      this.pageContent = this.el.nextSibling.nextSibling;
    }

    if (this.headerPositionFixed) {
      // If a Fixed Header exists, append the Fixed Panel to it and sets the
      // top margin of the parent of the Header to the height of the Header and Fixed Panel
      this.headerEl.appendChild(this.el);
      this.headerEl.parentNode.style['margin-top'] = (0, _outerHeight2.default)(this.headerEl) + this.panelHeight + 'px';
    }
  };

  /**
   * This method checks the current viewport size against the breakpoint
   * set in the configs, returning false if the viewport size is less
   * than or equal to the breakpoint config and true if it is not.
   */


  FixedPanel.prototype._checkBreakPoint = function _checkBreakPoint() {

    // Gets the current breakpoint of the current window
    var windowWidth = window.innerWidth;
    var currentBreakpoint = (0, _breakpoint.get)(windowWidth);

    // Returns false if the current breakpoint is equal to the config breakpoint
    // or any other breakpoint that is smaller than the breakpoint config
    if (this.unlockBreakPoint === currentBreakpoint) {
      return false;
    }

    if (this.unlockBreakPoint === 'sm' && currentBreakpoint === 'xs') {
      return false;
    }

    if (this.unlockBreakPoint === 'md' && (currentBreakpoint === 'sm' || currentBreakpoint === 'xs')) {
      return false;
    }

    if (this.unlockBreakPoint === 'lg' && (currentBreakpoint === 'md' || currentBreakpoint === 'sm' || currentBreakpoint === 'xs')) {
      return false;
    }

    if (this.unlockBreakPoint === 'xl') {
      return false;
    }

    return true;
  };

  /**
   * This method fixes the Fixed Panel to the top of the viewport when a user has
   * scrolled beyond the Header or if no Header is present by default fixes to the
   * top of viewport.
   */


  FixedPanel.prototype._fixToTopViewport = function _fixToTopViewport() {
    var lockPanel = this._checkBreakPoint();

    if (this.currentScrollPosition > this.headerHeight) {
      if (lockPanel) {
        // When scrolled past the height of the Header, the Fixed Panel will fix
        // itself to the top of the viewport
        if (!(0, _hasClass2.default)(this.el, 'is-fixed-top')) {
          (0, _addClass2.default)(this.el, 'is-fixed-top');

          // Add top margin to the next element that is under the Fixed Panel
          this.pageContent.style['margin-top'] = this.panelHeight + 'px';
        }

        // Method call to condense the Fixed Panel, if the condense config is set
        this.condensePanel();
      }
    } else {
      if (this.headerHeight !== 0) {
        // Upon returning to the bottom of a present header the Fixed Panel will
        // dock to the bottom of the header
        if ((0, _hasClass2.default)(this.el, 'is-fixed-top')) {
          (0, _removeClass2.default)(this.el, 'is-fixed-top');

          // Eliminates top margin to the next element that is under the Fixed Panel
          this.pageContent.style['margin-top'] = 0 + 'px';
        }
      }

      // Method call to extend the Fixed Panel from a condensed state if the condense config is set
      this.extendPanel();
    }
  };

  /**
   * This method will show or hide the Fixed panel if it is currently out of view
   * and the user scrolls up or down
   */


  FixedPanel.prototype._showPanelOnScroll = function _showPanelOnScroll() {
    var totalHeight = this.headerHeight + this.panelHeight;

    // If scrolled down the height of the Header, and the Fixed Panel the Panel will hide.
    // If scrolled up the Fixed Panel will show, and if the header is in the viewport the Fix Panel
    // will dock to the bottom of the Header
    if (this.currentScrollPosition > totalHeight) {
      if (this.currentScrollPosition < this.previousScrollPosition) {
        this.showPanel();
      } else if (this.currentScrollPosition >= this.previousScrollPosition) {
        this.hidePanel();
      }
    }
  };

  /**
   * Trigger Event function is called to show the panel based off of a desired event
   */


  FixedPanel.prototype.showPanel = function showPanel() {
    if (this.fixToBottom) {
      (0, _removeClass2.default)(this.el, 'hide-panel-bottom');
    } else {
      (0, _removeClass2.default)(this.el, 'hide-panel-top');
    }
  };

  /**
   * Trigger Event function is called to hide the panel based off of a desired event
   */


  FixedPanel.prototype.hidePanel = function hidePanel() {
    if (this.fixToBottom) {
      (0, _addClass2.default)(this.el, 'hide-panel-bottom');
    } else {
      (0, _addClass2.default)(this.el, 'hide-panel-top');
    }
  };

  /**
   * Trigger Event function is called to condense the panel based off of a desired event
   */


  FixedPanel.prototype.condensePanel = function condensePanel() {

    // If a condense config is added than this checks for the a custom condense class
    // to apply to the Fixed Panel, if no class is provided than apply default class 'spark-panel--condensed'
    if (this.condenseOnScroll) {
      if (this.customCondenseClass) {
        (0, _addClass2.default)(this.el, this.customCondenseClass);
      } else {
        (0, _addClass2.default)(this.el, 'spark-panel--condensed');
      }
    }
  };

  /**
   * Trigger Event function is called to extend the panel from a condensed state based off of a desired event
   */


  FixedPanel.prototype.extendPanel = function extendPanel() {
    if (this.condenseOnScroll) {
      if (this.customCondenseClass) {
        (0, _removeClass2.default)(this.el, this.customCondenseClass);
      } else {
        (0, _removeClass2.default)(this.el, 'spark-panel--condensed');
      }
    }
  };

  /**
   * This method gets the height and location of the Header and also updates the
   * height of the Fixed Panel and Fixed Panel PlaceHolder to allow for the appropriate window modifications
   */


  FixedPanel.prototype._getPanelDimensions = function _getPanelDimensions() {
    this.panelHeight = this.el.getBoundingClientRect().height;

    if (this.fixToBottom) {
      (0, _addClass2.default)(this.el, 'is-fixed-bottom');
    } else if (this.headerEl) {
      this.headerTop = this.headerEl.getBoundingClientRect().top + this.currentScrollPosition;
      this.headerBottom = this.headerEl.getBoundingClientRect().bottom + this.currentScrollPosition;
      this.headerHeight = this.headerTop + (0, _outerHeight2.default)(this.headerEl);

      // Checks to see if the Header is fixed or not
      var position = window.getComputedStyle(this.headerEl, null).getPropertyValue('position');
      var lockPanel = this._checkBreakPoint();

      // If the Header is fixed no Header calculations are need, if not the height of the Header
      // based off it's position on the page is calculated
      if (position === 'fixed') {
        this.headerPositionFixed = true;
      } else {
        this.headerHeight = (0, _outerHeight2.default)(this.headerEl) + this.headerTop;
      }
      if (!lockPanel) {
        (0, _removeClass2.default)(this.el, 'is-fixed-top');

        if (this.pageContent) {
          this.pageContent.style['margin-top'] = 0;
        }
      }
    } else {
      var _lockPanel = this._checkBreakPoint();

      if (_lockPanel) {
        // Disregarding other configs, by default if a header is not provided and a
        // Spark header is not present Fixed Panel will fix to the top of viewport
        (0, _addClass2.default)(this.el, 'is-fixed-top');
        this.el.style['margin-bottom'] = this.panelHeight + 'px';
        this.headerHeight = 0;
      }
    }
  };

  /**
   * Update the margin or padding of the body element or Header based on the position of
   * the Fixed Panel and presence of a Header.
   */


  FixedPanel.prototype._updatePanels = function _updatePanels() {
    if (this.fixToBottom) {
      this.documentBody.style['padding-bottom'] = this.panelHeight + 'px';
    }

    // Checks the current breakpoint aganist that of the breakpoint config to determine
    // if the Fixed Panel will remian fixed to the top viewport
    var lockPanel = this._checkBreakPoint();

    if (!this.headerEl && !this.fixToBottom && lockPanel) {
      (0, _addClass2.default)(this.el, 'is-fixed-top');
      this.documentBody.style['padding-top'] = this.panelHeight + 'px';
    }

    // Updates the margin of the parent node of the header to account for page content on resize
    if (this.headerPositionFixed) {
      this.headerEl.parentNode.style['margin-top'] = (0, _outerHeight2.default)(this.headerEl) + this.panelHeight + 'px';
    }
  };

  /**
   * On any resize event this method will recalculate the height of the header
   * as the Header may condense based off of window size, and adjusts the margin/padding
   * of elements if the Fixed Panel content wraps because of a smaller viewport size
   */


  FixedPanel.prototype._onResize = function _onResize() {
    this._getPanelDimensions();
    this.panelHeight = this.el.getBoundingClientRect().height;

    if (this.pageContent && parseInt(this.pageContent.style['margin-top']) > 0) {
      this.pageContent.style['margin-top'] = this.panelHeight + 'px';
    }

    this._updatePanels();
  };

  /**
   * On any scroll event this method will apply which ever variation and/or
   * config to the Fixed Panel on a scroll event
   */


  FixedPanel.prototype._onScroll = function _onScroll() {
    this.previousScrollPosition = this.currentScrollPosition;
    this.currentScrollPosition = window.pageYOffset !== undefined ? window.pageYOffset : window.document.body.scrollTop;
    this._getPanelDimensions();

    if (this.fixToBottom) {
      if (this.condenseOnScroll) {
        this._condensePanelonScroll();
      }
    } else {
      if (this.headerPositionFixed) {
        if (this.condenseOnScroll) {
          if (!this.foreignHeader) {
            this._onHeaderCondense();
          } else {
            this._condensePanelonScroll();
          }
        }
      } else if (!this.headerPositionFixed) {
        if (this.hideOnScroll) {
          this._showPanelOnScroll();
          this._fixToTopViewport();
        } else {
          this._fixToTopViewport();
        }
      }
    }

    this._showUntilElement();
  };

  /**
   * Add a condensed class to the Fixed Panel when scrolled an amount of pixels greater
   * than the height of the Fixed Panel
   */


  FixedPanel.prototype._condensePanelonScroll = function _condensePanelonScroll() {
    if (this.currentScrollPosition > this.panelHeight) {
      this.condensePanel();
    } else {
      this.extendPanel();
    }
  };

  /**
   * This method will show/hide the Fixed panel on scroll based on its position
   * relative to a specified page-level element (scrolledToEl)
   */


  FixedPanel.prototype._showUntilElement = function _showUntilElement() {
    if (!this.scrolledToEl || this.fixToBottom) {
      return;
    }

    var targetScrollPosition = void 0;

    // Calculates the scroll position of the targeted element for a Fixed Panel
    if (this.headerEl && (0, _hasClass2.default)('spark-header--fixed')) {
      // If the Header is fixed, the height of the header is factored into the calculations
      targetScrollPosition = this.scrolledToEl.getBoundingClientRect().top + window.pageYOffset - ((0, _outerHeight2.default)(this.el) + (0, _outerHeight2.default)(this.headerEl));
    } else {
      targetScrollPosition = this.scrolledToEl.getBoundingClientRect().top + window.pageYOffset - (0, _outerHeight2.default)(this.el);
    }

    // If the current scroll position is greater or equal to the top of the target position
    // than the Fixed Panel hides, else it remains visible
    if (this.currentScrollPosition >= targetScrollPosition) {
      this.hidePanel();
    } else {
      this.showPanel();
    }
  };

  /**
   * This method will apply/disable the condensed class onto the Fixed Panel at the same time as the Header requires
   * use of the Spark Header.
   */


  FixedPanel.prototype._onHeaderCondense = function _onHeaderCondense() {
    if ((0, _hasClass2.default)(this.headerEl, "spark-header--condensed")) {
      this.condensePanel();
    } else {
      this.extendPanel();
    }
  };

  return FixedPanel;
}(_base2.default);

/**
 * Whitelisted parameters which can be set on construction.
 * @type {Array}
*/


FixedPanel.prototype._whitelistedParams = ['headerEl', 'scrolledToEl', 'unlockBreakPoint', 'hideOnScroll', 'condenseOnScroll', 'fixToBottom', 'customCondenseClass'];

/**
 * Default values for internal properties we will be setting.
 * These are set on each construction so we don't leak properties
 * into the prototype chain.
 * @type {Object}
 */
FixedPanel.prototype.defaults = {
  el: null,
  scrolledToEl: null,
  headerEl: null,
  headerPosition: null,
  headerHeight: null,
  headerTop: null,
  headerPositionFixed: null,
  previousScrollPosition: null,
  currentScrollPosition: null,
  hideOnScroll: null,
  condenseOnScroll: null,
  fixToBottom: null,
  unlockBreakPoint: null,
  customCondenseClass: null,
  foreignHeader: null,
  panelHeight: null,
  documentBody: null,
  _onScrollBound: null,
  _onResizeBound: null
};

exports.default = FixedPanel;
module.exports = exports['default'];
//# sourceMappingURL=fixed-panel.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/js/dist/components/fixed-panel.js
// module id = 410
// module chunks = 0